(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Tri par défaut : du plus récent au plus ancien
  if (!url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'created-descending');
    window.history.replaceState({}, '', url);
    window.location.reload();
  }

  } catch(e) { console.error(e); }
})();
})();
